/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Icon } from '@hb/finance-ui';
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import platform from '@/shared/utils/platform';
import { callNative } from '@/shared/utils/bridge';
import { namespace } from 'vuex-class';
import { setPageTitle, setNativeNavBar } from '@/api/native/utils';
import { RouteRecord } from 'vue-router';
import type { AutarkyStateType } from '@/api/homeV2Status/types';
import { throttle } from 'lodash';
import {
  HomeThemeEnums, getThemeNavbarConfig,
} from '@/shared/utils/pageTheme';
import { RouterV2Enum } from '@/router/router-names';
import { AUTARKY_UPGRADE_PROCESS_STATE } from '@/views_v2/home/const';
import { skNativeContainer, skToTabbarPage } from '@/api/native/container';
import store from '@/store';
import { HOME_ALL_VERSION_ROUTE_PATHS } from '@/router/utils';
import { LeftArrowOutline24 } from '@hb/coffee-icons';

const HBridge = import('@hb/hbridge');

const style = require('./index.module.scss') as Dictionary;

const HomeStore = namespace('home');

const keyboardAppear = 'keyboard-appear';
const keyboardDisappear = 'keyboard-disappear';

export interface OldNavBarRef extends Vue {
  forceUpdateNavBarImageUse: () => void;
}

@Component({
  name: 'NavBar',
})
export default class NavBar extends Vue {
  @HomeStore.State autarkyState!: AutarkyStateType;

  @HomeStore.State homeThemeType!: HomeThemeEnums | null;

  // 页面标题
  @Prop({
    type: String,
    default: '',
  }) readonly title?: string;

  @Prop(Boolean) readonly show?: boolean;

  // 标题对齐方向
  @Prop({
    type: String,
    default: 'left',
  }) readonly textAlign?: string;

  @Prop(Boolean) readonly showCenterTitle?: boolean;

  // 是否固定在顶部
  @Prop({
    type: Boolean,
    default: true,
  }) readonly fixed?: boolean;

  // 右侧icon名称，配置规则同vant icon
  @Prop(String) readonly rightIcon?: string;

  // 标题栏颜色
  @Prop(String) readonly color?: string;

  // 标题字体大小
  @Prop(String) readonly fontSize?: string;

  // 左侧返回图标颜色，仅支持纯色
  @Prop(String) readonly leftColor?: string;

  // 右侧图标颜色
  @Prop(String) readonly rightColor?: string;

  // 标题栏背景色
  @Prop(String) readonly background?: string;

  // 状态栏背景颜色
  @Prop(String) readonly statusBarBackground?: string;

  // 是否展示状态栏
  @Prop({
    type: Boolean,
    default: true,
  }) readonly isShowAndroidStatusBar?: boolean;

  // 状态栏颜色，true深色文字, false浅色文字
  @Prop({
    type: Boolean,
    default: true,
  }) readonly isDarkStatusBar?: boolean;

  static instance: NavBar | null = null;

  /** 根据ab结果显示标题改造 begin, ab结果后可以删除 */
  private titleText = '';

  private backgroundComputed = '';

  // TODO: 此处有坑，如果colorComputed设置为undefined  无法依赖收集，不能触发Get方法
  private colorComputed: null | string = null ;
  /** 根据ab结果显示标题改造 end */

  private noImage = true;

  private isQualityHome = false;

  public static hide(): void {
    // 慎用该方法，参考信用卡（目前臻有钱无使用该方法的场景）
    if (NavBar.instance) {
      NavBar.instance.$emit('change', false);
    }
  }

  private created() {
    NavBar.instance = this;
  }

  // 控制H5 NavBar的显隐，保证在原生导航栏消失之后更新该值
  private isVisible = false;

  // 控制H5 标题栏是否为图片
  private useImage = false;


  /** 是否老户升级处理中状态，包含圈中升级 & 升级提交中 */
  private get isAutarkyProcessing() {
    return this.autarkyState
      && AUTARKY_UPGRADE_PROCESS_STATE.includes(this.autarkyState.autarkyUpgradeState);
  }

  @Watch('show', { deep: true, immediate: true })
  private adaptNavBar() {
    if (platform.isHelloApp && this.show !== undefined) {
      // 根据 show 值控制原生导航栏的显隐
      setNativeNavBar(!this.show);
      this.isVisible = this.show || false;
    }
  }

  /** 监听老户升级, 只监听品质首页 */
  @Watch('autarkyState', { immediate: true })
  private isAutarkyState() {
    if (this.autarkyState
      && this.autarkyState.autarky
      && this.autarkyState.autarkyUpgradeState
      && this.isAutarkyProcessing
      && this.$route.path === RouterV2Enum.qualityHomePage
    ) {
      this.noImage = false;
      this.useImage = true;
      this.colorComputed = '#fff';
      this.titleText = '';
      this.backgroundComputed = 'transparent';
    }
  }

  @Watch('$route', { immediate: true })
  private adaptAndroid(to: RouteRecord) {
    this.titleText = '';
    this.colorComputed = '#fff';

    const {
      statusBarBackground = 'transparent',
      isDarkStatusBar,
      useImage,
      background,
      color,
    } = this.$route.meta.navBarCustomProps || {};

    if (this.show) {
      // 清空上一页面遗留的pageTitle信息
      setPageTitle('');

      this.backgroundComputed = background;
      this.colorComputed = color;
      const isTaglessHome = to.path.includes('app-tagless-home');
      this.isQualityHome = to.path.includes('app-quality-home');
      const newQualityHome = this.isQualityHome;
      const isHome = to.path === '/v2/home';

      // 调整安卓设备状态栏颜色
      if ((platform.isAndroid || platform.isHarmony) && platform.isHelloApp) {
        const statusBarParams = {
          // 状态栏颜色-背景色：应该是无效设置（后续可删除）
          colorCode: statusBarBackground,
          // 是否显示状态栏, 安卓统一为不显示，避免h5导航栏闪动问题
          isShowStatusBar: false,
          // true深色文字, false浅色文字
          isDarkFont: isDarkStatusBar,
        };

        // 该方法仅在安卓设备有效，ios方法待扩展.callNative(JSON.stringify(data));
        callNative({
          classMap: 'NavBar',
          method: 'setStatusBarColor',
          params: statusBarParams,
        });
      }
      this.useImage = useImage;

      if (isTaglessHome || newQualityHome) {
        this.noImage = false;
      }

      this.titleText = newQualityHome || isTaglessHome || isHome ? '' : this.$route.meta.title;
    }
  }

  public forceUpdateNavBarImageUse(): void {
    const { useImage } = this.$route.meta.navBarCustomProps || {};

    this.useImage = useImage;
  }

  private async onClickLeft() {
    this.$ubtModuleExposeNew('finance_commonNavbar_pageExit', {
      currentPage: this.$route.path,
    });

    /** 臻有钱 我的 tab，回退的时候 要回到首页-为了尽可能的引导用户流量去首页 */
    if (await skNativeContainer()) {
      if (this.$route.path === RouterV2Enum.myProfile) {
        /** 回到首页tab */
        skToTabbarPage(
          {
            tabId: 'home',
          },
        );
      } else {
        (await HBridge).Native.goBack();
      }
    } else {
      (await HBridge).Native.goBack();
    }
  }

  private onClickRight() {
    this.$emit('clickRight');
  }

  private get renderLeft() {
    const { leftColor, colorComputed } = this;
    const slot = this.$slots.left;
    const isHome = window.location.href.includes('home');
    const { themeLeftIconColor } = getThemeNavbarConfig(this.homeThemeType, this.$route.name);

    if (slot) {
      return slot;
    }
    return (
    <LeftArrowOutline24
      class={style.leftIcon}
      style={leftColor && { color: isHome ? (themeLeftIconColor || colorComputed) : leftColor }}
      key={this.noImage}
      onClick={this.onClickLeft.bind(this)}
  />
    );
  }

  private get renderCenter() {
    const {
      textAlign, color, fontSize, showCenterTitle, title,
    } = this;
    const slot = this.$slots.default;
    const { titleLeft } = this.$slots;

    if (slot) {
      return slot;
    }

    const centerText = this.titleText || title;

    if (centerText) {
      return (
        <div
          class={style.title}
          style={[
            textAlign && { textAlign },
            color && { color: this.colorComputed },
            fontSize && { fontSize }]
          }
        >
          {(textAlign === 'center' || showCenterTitle) && centerText}
          {titleLeft && this.$slots.titleLeft}
        </div>
      );
    }
    return null;
  }

  /**
   * 渲染右侧图标
   * 目前工程中实际没有使用到右侧图标，后续可以删除
   */

  private get renderRight() {
    const { rightIcon, rightColor } = this;
    const slot = this.$slots.right;
    if (slot) {
      return slot;
    }
    return (
      <Icon
        class={style.rightIcon}
        style={rightColor && { color: rightColor }}
        name={rightIcon}
        onClick={this.onClickRight.bind(this)}
      />
    );
  }

  private get androidBgStyle() {
    return (platform.isAndroid || platform.isHarmony) && platform.isHelloApp ? 'bg-padding' : '';
  }

  /** 动态计算标题栏背景样式
   * 1. 品质首页的标题栏：navBarQualitBg
   * 2. 老户升级的标题栏：navBarBg
   * 3. 无标签首页的标题栏：navBarBg
   */

  private get navBgClass() {
    if (this.useImage) {
      if (this.isQualityHome && (this.autarkyState?.autarky && this.isAutarkyProcessing)) {
        return 'navBarBg';
      }

      if (this.isQualityHome) {
        return 'navBarQualitBg';
      }
      return 'navBarBg';
    }
    return '';
  }

  /** 当前页面input框是否点击后产生的聚焦 */
  private inputClickedFocus = false;

  /** 是否已唤起：输入法键盘 */
  private openedInputKeyboard = false;

  /** 唤起输入法键盘后，系统的滑动top值(ios) */
  private inputKeyboardScrollTop = 0;

  private mounted() {
    // 非iOS系统不处理后续的键盘处理逻辑
    if (!platform.isIOS) {
      return;
    }
    document.addEventListener('click', () => {
      const { tagName } = document.activeElement || {};

      if (tagName && ['INPUT', 'TEXTAREA'].includes(tagName)) {
        this.inputClickedFocus = true;
      }
    });

    window.addEventListener(keyboardAppear, () => {
      /** input框点击后获得焦点，才会触发软键盘状态变更 */
      if (this.inputClickedFocus) {
        this.openedInputKeyboard = true;
        this.inputClickedFocus = false;
      }
    });

    window.addEventListener(keyboardDisappear, () => {
      this.openedInputKeyboard = false;
      this.inputClickedFocus = false;
    });

    document.addEventListener('scroll', throttle(() => {
      this.inputKeyboardScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    }, 100));
  }

  private render() {
    const {
      color, fixed, backgroundComputed,
    } = this;
    const {
      isValidTheme,
      priorityImageUrl = '',
      bgTransitionStyle,
    } = getThemeNavbarConfig(this.homeThemeType, this.$route.name);
    const isHybridAppMode = store.state.base.isHybridAppMode
      && HOME_ALL_VERSION_ROUTE_PATHS.includes(this.$route.path as RouterV2Enum);

    return (
      <div class={style.navBarFragment}>
        {this.isVisible ? (
          <div class={[
            style.navBarContainer,
            isHybridAppMode ? style.hybridAppModeNavbar : '']}>
            <div
              class={[
                style.navBarWrap,
                fixed && style.fixedNavbarWrap,
                style[this.androidBgStyle],
                this.useImage && style[this.navBgClass],
                this.noImage && style.navBarNoBg,
              ]}
              style={[
                backgroundComputed && { backgroundColor: this.backgroundComputed },
                color && { color: this.colorComputed },
                this.openedInputKeyboard && { top: `${this.inputKeyboardScrollTop}px` },
                isValidTheme && bgTransitionStyle,
                isValidTheme && { backgroundImage: `url(${priorityImageUrl})` },
              ]}
            >
              {/** ios唤起输入键盘时，滑动过程增加bar内容高度，减少抖动 */}
              {this.openedInputKeyboard ? <p class={style.scrollOverflowBox}/> : null}
              <div
                class={[
                  style.navBar,
                  (platform.isAndroid || platform.isHarmony) && style.androidNavBar,
                ]}
                style={backgroundComputed && { backgroundColor: this.backgroundComputed }}
              >
                {this.renderLeft}
                {this.renderCenter}
                {this.renderRight}
              </div>
            </div>
          </div>
        ) : null}

      </div>
    );
  }
}
